/* global angular */
( function () {
	'use strict';

	function templatePdf ( pdfMakeProv, pdfCommonFactory, templateReportPdf ) {
		function generatePdf ( template, types ) {
			var pdfMake     = pdfMakeProv();
			var observation = {
				'template' : template,
				'tags'     : template.tags,
				'type'     : types
			};

			var templateBody = templateReportPdf.buildReport( [ observation ], {}, null, 'templatePage' );

			templateBody.pageBreak = null;

			var pdfContents = {
				'content' : [ templateBody ]
			};

			pdfContents.pageMargins  = [ 40, 45, 85, 45 ];
			pdfContents.styles       = pdfCommonFactory.pdfStyles();
			pdfContents.defaultStyle = {
				'font' : 'OpenSans'
			};

			pdfContents.pageBreakBefore = function ( currentNode ) {
				return currentNode.id === 'signature' && currentNode.startPosition.top > 660;
			};

			pdfMake.fonts = {
				'OpenSans' : {
					'normal'      : 'OpenSans-Regular.ttf',
					'bold'        : 'OpenSans-Bold.ttf',
					'italics'     : 'OpenSans-Italic.ttf',
					'bolditalics' : 'OpenSans-BoldItalic.ttf'
				}
			};

			pdfMake.createPdf( pdfContents ).download( template.name.split( ' ' ).join( '.' ) + '.pdf' );
		}

		return {
			'generatePdf' : generatePdf
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'templatePdf', templatePdf );

	templatePdf.$inject = [ 'pdfMake', 'pdfCommonFactory', 'templateReportPdf' ];
} )();
